import React from 'react';
import { Icon } from '@/shared/icons';
import type { IconName } from '@/shared/icons';

/**
 * Card de seção do mockup agent-form: header (tile lilás 34px + título 15 +
 * subtítulo) DENTRO do card, corpo com padding. Padrão de TODAS as abas do
 * AgentForm (referência: BasicTab/BehaviorTab).
 */
export const SectionCard: React.FC<{
  icon: IconName;
  title: React.ReactNode;
  subtitle?: string;
  /** Slot à direita do header (badges, toggles, botões) */
  actions?: React.ReactNode;
  children: React.ReactNode;
  /** Corpo sem padding (listas/editores full-bleed) */
  flush?: boolean;
}> = ({ icon, title, subtitle, actions, children, flush = false }) => (
  <div
    className="rounded-xl overflow-hidden"
    style={{ backgroundColor: 'var(--theme-card-background)', border: '1px solid var(--theme-card-border)' }}
  >
    <div
      className="flex items-center gap-3 p-4 flex-wrap"
      style={{ borderBottom: '1px solid var(--theme-card-border)' }}
    >
      <span
        className="flex items-center justify-center flex-none rounded-[10px]"
        style={{ width: 34, height: 34, backgroundColor: 'var(--theme-primary-background)', color: 'var(--theme-primary)' }}
      >
        <Icon name={icon} size={16} />
      </span>
      <div className="min-w-0 flex-1">
        <h3 className="text-[15px] font-semibold" style={{ color: 'var(--theme-card-text)' }}>{title}</h3>
        {subtitle && (
          <p className="text-xs" style={{ color: 'var(--theme-muted-text)' }}>{subtitle}</p>
        )}
      </div>
      {actions}
    </div>
    <div className={flush ? '' : 'p-4'}>{children}</div>
  </div>
);

SectionCard.displayName = 'SectionCard';
